import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'propertyTypeCanonical',
})
export class PropertyTypeCanonicalPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): string {
    switch (value) {
      case 'flat':
        return 'Flat';
      case 'semi_detached':
        return 'Semi detached';
      case 'detached':
        return 'Detached';
      case 'terraced':
        return 'Terraced';
      default:
        return 'Other';
    }
  }
}
